import { DocumentModel } from '@/models/document.model';
import { ValidatorResult } from '@/models/validation-result.model';
import { OrderItemDto } from '@onrunning/backstage-models';
import { CrudService } from './crud.service';

export class OrderItemsService {
  private crudService: CrudService<OrderItemDto>;

  constructor() {
    this.crudService = new CrudService<OrderItemDto>('order-items');
  }

  public async getUnshippedItems(accountId: string): Promise<ValidatorResult<OrderItemDto[]>> {
    const queryParams = new URLSearchParams();
    queryParams.set('accountId', accountId);

    return await this.crudService.do('get', `unshipped?${queryParams}`);
  }

  public async downloadBackorderItems(accountId: string): Promise<ValidatorResult<DocumentModel | undefined>> {
    const queryParams = new URLSearchParams();
    queryParams.set('accountId', accountId);

    return await this.crudService.do('get', `download-xls?${queryParams}`);
  }
}
